/**
 *  @class
 *  @function ProductStack
 */
class ProductStack {
    constructor() {
   
    
    const heightmap = document.querySelector('.heightmap').querySelector(".cls-3");
    const cards = [...document.querySelectorAll(".card")];
    // const scrollContainer = document.querySelector(".scroll-container");
    // const handlers = cards.map((_, index) => {
    //     const cardsToScale = cards.slice(0, index + 1);
    //     const from = (100 / cards.length) * (index );
    //     const to = from + 4;
    //     return (actual) => {
    //         scrollHandler(from, to, (actual) => {
    //             cardsToScale.forEach((card, index) => {
    //                 // scale last card from 1 to 0.98
    //                 // scale second last card from 0.98 to 0.96
    //                 // scale third last card from 0.96 to 0.94
                    
    //                 const scaleFrom = 1 - (cardsToScale.length - index) * 0.02;
        
    //                 const scale = scaleFrom + 0.02 * (actual - to) / (from - to);
    //                 if(window.innerWidth >= 1024){
                    
    //                 card.style.transform = `scale(${scale})`;
    //             }
    //             })
    //         }, actual);
    //     };
    // });

    // const scrollHandler = (from, to, callback, actual) => {
    //     if (actual >= from && actual <= to) {
    //         callback(actual);
    //     }
    // }
    
    document.addEventListener("scroll", () => {
        cards.forEach((card, index) => {
            let upperBound = 152 + ((index + 1) * 16);
            let lowerBound = 304 + ((index + 1) * 16);
            if(card.getBoundingClientRect().top < lowerBound && card.getBoundingClientRect().top > upperBound){
                heightmap.setAttribute("stroke", card.getAttribute('color'));
            }
            });

        // const top = scrollContainer.getBoundingClientRect().top;
        // if(top > 0 || top < scrollContainer.clientHeight * -1){
        //     return;
        // }

        // const actual = -100 * top / scrollContainer.clientHeight;
        // handlers.forEach(handler => {
        //     handler(actual);
        // });
    });
}
  }
  
  if (typeof ProductStack !== 'undefined') {
      new ProductStack();
  }
  
